import * as yup from 'yup';
import Base from './Base';

const createSchema = yup.object().shape({
  dateOfBirth: yup.date().required('Date of birth is required').isDOB(),
  email: yup.string().email('Invalid email format').required('Email is required'),
  gender: yup.string().oneOf(['female', 'male', 'other'], 'Gender must be female, male, or other').required('Gender is required'),
  name: yup.string().required('Name is required'),
  phoneNumber: yup.string().required('Phone number is required').isPhone(),
  preferredName: yup.string().required('Preferred name is required'),
  preferredReportDate: yup.date().required('Preferred report date is required').isReportDate(),
  questionText: yup.string().required('Question text is required'),
});

const completeSchema = yup.object().shape({
  dateOfBirth: yup.date().required('Date of birth is required').isDOB(),
  email: yup.string().email('Invalid email format').required('Email is required'),
  gender: yup.string().oneOf(['female', 'male', 'other'], 'Gender must be female, male, or other').required('Gender is required'),
  name: yup.string().required('Name is required'),
  phoneNumber: yup.string().required('Phone number is required').isPhone(),
  preferredName: yup.string().required('Preferred name is required'),
  preferredReportDate: yup.date().isReportDate(),
});

const lawFirmSchema = yup.object().shape({
  argument: yup.string().required('Argument is required'),
  caseInformation: yup.string().required('Case information is required'),
  dateOfBirth: yup.date().required('Date of birth is required').isDOB(),
  employer: yup.string().required('Employer is required'),
  gender: yup.string().oneOf(['female', 'male', 'other'], 'Gender must be female, male, or other').required('Gender is required'),
  name: yup.string().required('Name is required'),
  preliminaryDate: yup.date().required('Preliminary date is required').isFutureDate(),
});

const requestReportSchema = yup.object().shape({
  dateOfBirth: yup.date().isDOB(),
  gender: yup.string().oneOf(['female', 'male', 'other'], 'Gender must be female, male, or other'),
  phoneNumber: yup.string().isPhone(),
  preferredName: yup.string().required('Preferred name is required'),
  question: yup.string(),
  reportDate: yup.date().isReportDate(),
});

const onlinePortalAccessSchema = yup.object().shape({
  portalAddress: yup.string().required('Portal address is required'),
  portalPassword: yup.string().required('Portal password is required'),
  portalUsername: yup.string().required('Portal username is required'),
  studyName: yup.string().required('Study name is required'),
});

const onlineFolderLinkSchema = yup.object().shape({
  onlineServiceName: yup.string().required('Online service name is required').max(40, 'Online service name must be 40 characters or less'),
  sharingLink: yup.string().required('Sharing link is required').url('Invalid URL format'),
  studyDescription: yup.string().required('Study description is required').max(200, 'Study description must be 200 characters or less'),
});

const clinicUploadSchema = yup.object().shape({
  studyDetails: yup.string().required('Study details is required'),
});

export default class CreateCaseModel extends Base {
  static validateCreate(item, fields) {
    return super.validate(item, fields, createSchema);
  }

  static validateComplete(item, fields) {
    return super.validate(item, fields, completeSchema);
  }

  static validateRequestReport(item, fields) {
    return super.validate(item, fields, requestReportSchema);
  }

  static validateOnlinePortalAccess(item, fields) {
    return super.validate(item, fields, onlinePortalAccessSchema);
  }

  static validateOnlineFolderLink(item, fields) {
    return super.validate(item, fields, onlineFolderLinkSchema);
  }

  static validateClinicUpload(item, fields) {
    return super.validate(item, fields, clinicUploadSchema);
  }

  static validateLawFirm(item, fields) {
    return super.validate(item, fields, lawFirmSchema);
  }

  preferredReportDate = new Date();
  name = '';
  preferredName = '';
  phoneNumber = '';
  email = '';
  dateOfBirth = new Date();
  preliminaryDate = new Date();
  questionText = '';
  gender = null;
}
